// Mutation hook: odrzucenie koszyka w workflow akceptacji

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

type IResponse = ICommandResponseSuccess;

export interface IPayload {
  reason: string;
}

const postCartToApproveReject = (cartId: number, payload: IPayload): Promise<IResponse> =>
  axios.post(`/carts-to-approve/${cartId}/reject`, payload);

export const usePostCartToApproveReject = (
  cartId: number,
  options?: UseMutationOptions<IResponse, IError, IPayload>
) =>
  useMutation<IResponse, IError, IPayload>(
    (payload) => postCartToApproveReject(cartId, payload),
    options
  );
